var exports = {
  "S": "xa15a2ab7--79d250--show-more",
  "V": "xa15a2ab7--79d250--show-more-btn",
};

module.exports = exports;
